import axios from 'axios'

/**
 * `HasActiveSubscription` carries the machine-readable code
 * `subscription_inactive`, but DRF serialises an ErrorDetail as a bare string,
 * so today only the message reaches the client. The code is checked first
 * regardless, so that if the backend ever renders it this keeps working with no
 * change here; the message match is the fallback for as long as it does not.
 */
const LIMITED_MODE_CODE = 'subscription_inactive'
const LIMITED_MODE_DETAIL = 'An active subscription is required.'

// Some viewsets wrap responses in CustomJSONRenderer ({ data: { detail } }) and
// some do not ({ detail }). Accept either.
const hasLimitedModeCode = (body: any): boolean =>
  body?.code === LIMITED_MODE_CODE || body?.detail?.code === LIMITED_MODE_CODE

const hasLimitedModeDetail = (body: any): boolean =>
  body?.detail === LIMITED_MODE_DETAIL

/** Whether an error body is the backend refusing an unactivated account. */
export const isLimitedModeError = (data: any): boolean =>
  [data, data?.data].some(
    (body) => hasLimitedModeCode(body) || hasLimitedModeDetail(body),
  )

/**
 * Whether a thrown error is that refusal, status and all.
 *
 * Deliberately narrower than "the request failed" or even "the request was
 * refused": a refusal has many causes, and only this one is known in advance to
 * be unanswerable. Anything else - a different permission denial, a network
 * failure, a 5xx - is none of this module's business and keeps its normal
 * handling.
 */
export const isLimitedModeRefusal = (error: unknown): boolean =>
  axios.isAxiosError(error) &&
  error.response?.status === 403 &&
  isLimitedModeError(error.response.data)
